import { Component } from "@angular/core";
import { PopupDialogExampleComponent } from "./popup-dialog-example.component";
import { PopupService } from 'src/app/services';
import { PopupData } from "./popup-data";

@Component({
    template: '<button (click)="showPopup()">Show</button>',
    standalone: false
})
export class PopupExampleComponent {
    constructor(private popupService: PopupService) { }

    showPopup() {
        const data: PopupData = {message: 'This text is inside of a popup.'}
        this.popupService.open(PopupDialogExampleComponent, 'Example popup', data);
    }
}
